var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.renderData
    ? _c(
        "div",
        {
          class: `mSlot mSlot-border-${
            _vm.$vuetify.theme.dark ? "dark" : "light"
          }`
        },
        [_vm._v(" " + _vm._s(_vm.renderData.text) + " ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }